import { shallowEqual, useSelector } from 'react-redux';
import { getAccountStatistics } from '../selectors';

export const useAccountStatistic = () => ({
  statistic: useSelector(getAccountStatistics, shallowEqual),
});
